import { render, staticRenderFns } from "./MyZoom.vue?vue&type=template&id=5f31e798&"
import script from "./MyZoom.vue?vue&type=script&lang=ts&"
export * from "./MyZoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports